<template>
  <div id="repairModeManage" class="container">
    <el-col style="width:100%">
      <el-form
        :inline="true"
        label-width="100px"
        :label-position="labelPosition"
      >
        <el-form-item style="margin-bottom: 15px;width:150px">
          <el-select
            clearable
            filterable
            v-model="defaultBrandId"
            placeholder="请选择品牌"
            @change="selectBrand"
          >
            <el-option
              :label="item.brandName"
              :value="item.brandId"
              v-for="(item, index) in brandLists"
              :key="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-bottom: 15px;width:150px">
          <el-select
            clearable
            filterable
            v-model="defaultCategoryId"
            placeholder="请选择品类"
            @change="selectCategory"
          >
            <el-option
              :label="item.categoryName"
              :value="item.categoryId"
              v-for="(item, index) in categoryLists"
              :key="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-bottom: 15px;width:180px">
          <el-select
            clearable
            filterable
            v-model="defaultModelId"
            placeholder="请选择型号"
            @change="selectModel"
          >
            <el-option
              :label="item.modelName"
              :value="item.modelId"
              v-for="(item, index) in modelLists"
              :key="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-bottom: 15px;width:150px">
          <el-select
            clearable
            filterable
            v-model="defaultFaultClassId"
            placeholder="请选择故障大类"
            @change="selectFaultClassId"
          >
            <el-option
              :label="item.faultTypesName"
              :value="item.faultTypesId"
              v-for="(item, index) in faultClassLists"
              :key="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!--
        <el-form-item style="margin-bottom: 15px;width:150px">
          <el-select
            clearable
            filterable
            v-model="defaultSubClassId"
            placeholder="请选择故障小类"
            @change="getModelFaultSolutionList"
          >
            <el-option
              :label="item.faultSubclassName"
              :value="item.faultSubclassId"
              v-for="(item, index) in faultSubClassLists"
              :key="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        -->
        <el-form-item style="margin-bottom: 15px;width:100px">
          <el-select
            clearable
            filterable
            v-model="statusList.state"
            placeholder="状态"
          >
            <el-option
              v-for="(item, index) in statusList"
              :label="item.paraName"
              :value="item.paraValue"
              :key="index"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="margin-bottom: 15px;width:100px">
          <el-select
            clearable
            filterable
            v-model="officialAccessoriesList.state"
            placeholder="渠道类型"
          >
            <el-option
              v-for="(item, index) in officialAccessoriesList"
              :label="item.paraName"
              :value="item.paraValue"
              :key="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="width:160px;margin-bottom:15px">
          <el-input
            clearable
            v-model.trim="searchSkuNo"
            placeholder="SKU搜索"
          ></el-input>
        </el-form-item>

        <el-form-item style="margin-bottom: 15px;">
          <el-button type="primary" @click="onSubmit()" size="small"
            >查询</el-button
          >
          <el-button
            type="text"
            @click="clearFrom()"
            style="width: 60px;color: #169BD5;"
            >重置</el-button
          >
        </el-form-item>
        <el-form-item class="fr" style="text-align:right">
          <el-button
            type="success"
            v-if="basicsAuth.exportModelFaultSolution"
            size="small"
            @click="downLoad.exportExcel('tableId')"
            >导出当页数据</el-button
          >
          <i
            class="el-icon-refresh"
            style="font-size: 25px;cursor: pointer;margin-left: 30px;"
            @click="refresh()"
          ></i>
        </el-form-item>
      </el-form>
    </el-col>
    <el-card class="box-card">
      <el-table
        :data="returnData"
        border
        id="tableId"
        :header-cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column
          fixed
          align="center"
          width="90"
          prop="extendValue"
          label="SKU"
        >
        </el-table-column>
        <el-table-column
          fixed
          align="center"
          width="100"
          prop="faultTypesName"
          label="故障分类"
        >
        </el-table-column>
        <el-table-column
          align="center"
          width="160"
          label="故障"
          prop="faultSubclassName"
        >
        </el-table-column>
        <el-table-column
          align="center"
          width="200"
          prop="solutionName"
          label="维修方式"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.solutionName }}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" prop="duration" label="维修时长">
          <template slot-scope="scope">
            <span v-if="scope.row.duration">
              {{ scope.row.duration }}分钟
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="warrantyPeriod" label="保修时长">
          <template slot-scope="scope">
            <span v-if="scope.row.warrantyPeriod">
              {{ scope.row.warrantyPeriod }}天
            </span>
          </template>
        </el-table-column> -->
        <el-table-column align="center" prop="price" label="维修报价">
          <template slot-scope="scope">
            <span v-if="scope.row.price"> {{ scope.row.price }}元 </span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="officialPrice" label="官方价格">
          <template slot-scope="scope">
            <span v-if="scope.row.officialPrice">
              {{ scope.row.officialPrice }}元
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="originalPrice" label="描述">
          <template slot-scope="scope">
            <span v-if="scope.row.originalPrice">
              {{ scope.row.originalPrice }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="state" label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.officialAccessories == 2">官方部件</span>
            <span v-else-if="scope.row.officialAccessories == 1"
              >非官方部件</span
            >
            <span v-else-if="scope.row.officialAccessories == 3"
              >爱回收非官方部件</span
            >
            <span v-else-if="scope.row.officialAccessories == 4"
              >爱回收官方部件</span
            >
            <span v-else-if="scope.row.officialAccessories == 5"
              >爱回收手艺人</span
            >
            <span v-else-if="scope.row.officialAccessories == 7"
              >爱回收保险手艺人</span
            >
            <span v-else-if="scope.row.officialAccessories == 0"
              >金牌手艺人</span
            >
            <span v-else>其他</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="state" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 1">启用</span>
            <span v-else>禁用</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="partType" label="SKU类型">
          <template slot-scope="scope">
            <span v-if="scope.row.partType == 0">官方</span>
            <span v-else-if="scope.row.partType == 1">三方</span>
            <span v-else>其他</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="isDiscounts" label="是否打折">
          <template slot-scope="scope">
            <span v-if="scope.row.isDiscounts == 1">打折</span>
            <span v-else>不打折</span>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="state" label="渠道类型">
          <template slot-scope="scope">
            <span v-if="scope.row.partChannel == 1">极吼吼</span>
            <span v-else-if="scope.row.partChannel == 2">全服到家</span>
            <span v-else-if="scope.row.partChannel == 5">爱回收手艺人</span>
            <span v-else-if="scope.row.partChannel == 0">金牌手艺人</span>
            <span v-else-if="scope.row.partChannel == 6">全服快修</span>
            <span v-else-if="scope.row.partChannel == 7">爱回收保险手艺人</span>
            <span v-else>其他</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="partNameType" label="部件类型">
          <template slot-scope="scope">
            <span v-if="scope.row.partNameType == 1">电池</span>
            <span v-else-if="scope.row.partNameType == 2">屏幕</span>
            <span v-else>其他</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="120"
          label="操作"
          v-if="basicsAuth.deleteModelFaultSolution"
        >
          <template slot-scope="scope">
            <el-button
              @click.stop="exitBtn(scope.$index, scope.row)"
              type="text"
              size="small"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-col :span="24" class="toolbar">
        <div class="pagination">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pages.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pages.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="pages.total"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-card>
    <el-dialog
      title="编辑"
      :visible.sync="dislog"
      :close-on-click-modal="false"
      width="700px"
      @close="emptyDialog"
    >
      <el-form
        ref="exitForm"
        :model="exitForm"
        label-width="120px"
        :rules="exitFormRules"
        :label-position="labelPosition"
      >
        <el-form-item label="故障名称：">
          <el-input
            clearable
            v-model.trim="exitForm.faultTypesName"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="维修方式：">
          <el-select
            filterable
            style="width: 100%"
            placeholder="请选择维修方式"
            :filter-method="dataFilter(exitForm.solutionName, repairLists)"
            v-model="exitForm.solutionId"
            @change="getSolution"
          >
            <el-option
              :key="m.solutionId"
              v-for="(m, j) in repairLists"
              :label="m.solutionName"
              :value="m.solutionId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型：">
          <el-select
            style="width: 100%"
            placeholder="请选择是否为官方部件"
            v-model="exitForm.officialAccessories"
          >
            <el-option label="官方部件" value="2"></el-option>
            <el-option label="非官方部件" value="1"></el-option>
            <el-option label="金牌手艺人" value="0"></el-option>
            <el-option label="爱回收非官方部件" value="3"></el-option>
            <el-option label="爱回收官方部件" value="4"></el-option>
            <el-option label="爱回收手艺人" value="5"></el-option>
            <el-option label="爱回收保险手艺人" value="7"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="价格：" prop="price">
          <el-input
            style="width:80%"
            clearable
            v-model.trim="exitForm.price"
            oninput="this.value=this.value.replace(/\D/g,'')"
            type="number"
          ></el-input>
          <span>(单位：元)</span>
        </el-form-item>
        <el-form-item label="原价：" prop="officialPrice">
          <el-input
            style="width:80%"
            clearable
            v-model.trim="exitForm.officialPrice"
            oninput="this.value=this.value.replace(/\D/g,'')"
            type="number"
          ></el-input>
          <span>(单位：元)</span>
        </el-form-item>
        <el-form-item label="描述：">
          <el-input
            style="width:80%"
            placeholder="不要超过五个字"
            clearable
            v-model.trim="exitForm.originalPrice"
            type="text"
          ></el-input>
        </el-form-item>

        <el-form-item label="SKU类型：">
          <el-select
            style="width: 100%"
            placeholder="请选择SKU类型"
            v-model="exitForm.partType"
          >
            <el-option label="三方" value="1"></el-option>
            <el-option label="官方" value="0"></el-option>
            <!-- <el-option label="其他" value="2"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="是否打折：">
          <el-select
            style="width: 100%"
            placeholder="请选择是否根据原价打折"
            v-model="exitForm.isDiscounts"
          >
            <el-option label="打折" value="1"></el-option>
            <el-option label="不打折" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道类型：">
          <el-select
            style="width: 100%"
            placeholder="请选择渠道类型"
            v-model="exitForm.partChannel"
          >
            <el-option label="极吼吼" value="1"></el-option>
            <el-option label="全服到家" value="2"></el-option>
            <el-option label="金牌手艺人" value="0"></el-option>
            <el-option label="爱回收手艺人" value="5"></el-option>
            <el-option label="全服快修" value="6"></el-option>
            <el-option label="爱回收保险手艺人" value="7"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部件类型：">
          <el-select
            style="width: 100%"
            placeholder="请选择部件类型"
            v-model="exitForm.partNameType"
          >
            <el-option label="电池" value="1"></el-option>
            <el-option label="屏幕" value="2"></el-option>
            <el-option label="其他" value="999"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="维修时长：">
          <el-input
            style="width:80%"
            maxlength="4"
            oninput="this.value=this.value.replace(/\D/g,'').replace(/^0{1,}/g,'')"
            clearable
            v-model.trim="exitForm.duration"
            type="number"
          ></el-input>
          <span>(单位：小时)</span>
        </el-form-item>
        <el-form-item label="保修时长：">
          <el-input
            style="width:80%"
            maxlength="4"
            oninput="this.value=this.value.replace(/\D/g,'').replace(/^0{1,}/g,'')"
            clearable
            v-model.trim="exitForm.warrantyPeriod"
          ></el-input>
          <span>(单位：天)</span>
        </el-form-item>
        <el-form-item label="详情图片：">
          <el-upload
            class="avatar-uploader"
            :data="postData"
            action="https://up.qiniup.com"
            :show-file-list="false"
            :accept="acceptImage"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过5Mb
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="状态：" v-if="exitForm.solutionName !== ''">
          <el-switch
            v-model="exitForm.state"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item label="横线：">
          <el-switch
            v-model="exitForm.isShowLine"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>

        <el-form-item label="适用服务模式：">
          <el-checkbox-group v-model="exitForm.serviceMode">
            <el-checkbox label="1">到店维修</el-checkbox>
            <el-checkbox label="2">上门维修</el-checkbox>
            <el-checkbox label="3">邮寄维修</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="
            exitForm.modelFaultSolutionId !== '' &&
              exitForm.modelFaultSolutionId !== null
          "
          type="success"
          @click="saveStateSubmitBtn('exitForm')"
          >修改</el-button
        >
        <el-button
          v-else
          type="success"
          @click="saveEventFormSubmitBtn('exitForm')"
          >新增</el-button
        >
        <el-button @click="emptyDialog">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import store from "../../store/store";
import { genUpToken } from "./com/qiniuToken.js";
import {
  selectSolution,
  selectfaultTypes,
  //selectFaultSubclass,
  selectModelFaultTypes,
  selectAllBrand,
  selectCategory,
  selectModel,
  insertModelFaultSolution,
  selectModelFaultSolution,
  deleteModelFaultSolution,
  selectParameterInfoBusiness
} from "../../api/api";
import { getPermission } from "../../api/authRequest";
export default {
  inject: ["reload"],
  name: "repairModeManage",
  data() {
    const validateNumber = (rule, value, callback) => {
      if (!/^[+]{0,1}(\d+)$/.test(value)) {
        callback(new Error("价格只能为整数"));
      } else {
        callback();
      }
    };
    return {
      officialAccessories: "1",
      selectSolutionId: "",
      faultTypesList: [],
      exitTxt: "编辑",
      defaultFaultTypesId: "",
      defaultFaultSubclassId: "",
      postData: { token: "" },
      acceptImage: "image/jpeg,image/jpg,image/png",
      searchSkuNo: "",
      labelPosition: "left",
      rowAndColumn: {},
      exitForm: {
        faultSubclassId: "",
        faultSubclassName: "",
        solutionId: "",
        modelFaultSolutionId: "",
        officialAccessories: "1",
        state: "",
        price: "",
        duration: "", //维修时长
        warrantyPeriod: "", //保修时长
        extendValue: "", //详情图片
        originalPrice: 0, //原价
        isShowLine: "",
        officialPrice: 0, //官方价格
        partType: "", //类型
        isDiscounts: "", //是否打折
        partNameType: "", //部件名称类型
        partChannel: "", //渠道类型
        serviceMode: [] //适用服务模式
      },
      exitFormRules: {
        duration: [
          { required: true, message: "请输入维修时长", trigger: "blur" }
        ],
        warrantyPeriod: [
          { required: true, message: "请输入保修时长", trigger: "blur" }
        ],
        price: [{ required: true, validator: validateNumber, trigger: "blur" }],
        originalPrice: [
          { required: true, message: "请输入原价", trigger: "blur" }
        ]
      },
      dislog: false,
      selectContent: true,
      showSelect: false,
      defaultBrandId: "",
      defaultCategoryId: "",
      defaultModelId: "",
      brandLists: "",
      categoryLists: "",
      modelLists: "",
      activeBrandIndex: 0,
      activeCategoryIndex: 0,
      activeModelIndex: "",
      returnData: [],
      repairLists: [],
      baseUrl: "http://192.168.1.139:8087/",
      postData: { token: "" },
      fileList: [],
      qiniuaddr: "pic.allscs.cn", // 这是七牛云空间的外链默认域名
      ruleImg: "imageView2/0/q/75|imageslim", //规则
      imageUrl: "",
      acceptImage: "image/jpeg,image/jpg,image/png",
      faultClassLists: [],
      faultSubClassLists: [],
      defaultFaultClassId: "",
      defaultSubClassId: "",
      //分页变量
      pages: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      statusList: [
        {
          paraName: "启用",
          paraValue: "1"
        },
        {
          paraName: "禁用",
          paraValue: "0"
        }
      ],
      officialAccessoriesList: [
        {
          paraName: "金牌手艺人",
          paraValue: 0
        },
        {
          paraName: "极吼吼",
          paraValue: 1
        },
        {
          paraName: "全服到家",
          paraValue: 2
        },
        {
          paraName: "爱回收手艺人",
          paraValue: 5
        },
        {
          paraName: "全服快修",
          paraValue: 6
        }
      ],
      basicsAuth: {
        deleteModelFaultSolution: false,
        exportModelFaultSolution: false
      }
    };
  },
  mounted() {
    this.getModelFaultTypesList();
    this.getBrandLists();
    this.getRepairList();
    this.getFaultTypesList();
    this.basicsAuth.deleteModelFaultSolution = getPermission(
      "/api/basicSetting/ModelFaultSolution/deleteModelFaultSolution"
    );
    this.basicsAuth.exportModelFaultSolution = getPermission(
      "/api/basicSetting/ModelFaultSolution/exportModelFaultSolution"
    );
    this.getComponentClass();
  },
  components: {},
  methods: {
    //查询部件类型
    getComponentClass() {
      selectParameterInfoBusiness({
        paraType: "official_accessories_type",
        startRow: 1,
        pageSize: 10000
      }).then(res => {
        if (res.data.status == 100) {
          this.officialAccessories = 1;
        }
      });
    },
    //获取故障大类
    getFaultTypesList() {
      selectfaultTypes()
        .then(res => {
          if (res.data.status == 100) {
            this.faultClassLists = res.data.results;
            this.defaultFaultClassId = res.data.results[0].faultTypesId;
            //this.getFaultList();
            // console.log(res.data.results)
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //获取故障小类
    /*
    getFaultList() {
      selectFaultSubclass({ faulttypesId: this.defaultFaultClassId })
        .then(res => {
          if (res.data.status == 100) {
            this.faultSubClassLists = res.data.results;
            if (res.data.results.length > 0) {
              this.defaultSubClassId = res.data.results[0].faultSubclassId;
            } else {
              this.defaultSubClassId = "";
            }
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },*/
    handleModelAvatarSuccess(res, file) {
      this.imageUrl = "http://" + this.qiniuaddr + "/" + res.key + "?imageslim";
      this.modelForm.detailUrl = this.imageUrl;
    },
    beforeAvatarUpload(file) {
      const isPNG = file.type === "image/png";
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG 格式 和Png 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 10MB!");
      }
      return isLt2M;
    },
    refresh() {
      this.getModelFaultSolutionList();
    },
    onSubmit() {
      this.getModelFaultSolutionList();
    },
    clearFrom() {
      this.defaultBrandId = "";
      this.defaultCategoryId = "";
      this.defaultModelId = "";
      this.defaultFaultClassId = "";
      this.getModelFaultSolutionList();
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getModelFaultSolutionList();
    },
    handleCurrentChange(Page) {
      this.pages.page = Page;
      this.getModelFaultSolutionList();
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = "http://" + this.qiniuaddr + "/" + res.key + "?imageslim";
      console.log(this.imageUrl);
      this.exitForm.detailUrl = this.imageUrl;
    },
    beforeAvatarUpload(file) {
      const isPNG = file.type === "image/png";
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG 格式 和Png 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 10MB!");
      }
      return isLt2M;
    },
    dataFilter(val, options) {
      // this.value = val;
      // if (val) { //val存在
      //   options = options.filter((item) => {
      //     if (!!~item.label.indexOf(val) || !!~item.label.toUpperCase().indexOf(val.toUpperCase())) {
      //       return true
      //     }
      //   })
      // } else { //val为空时，还原数组
      //   //this.options = this.optionsCopy;
      // }
    },
    getMethod(data) {
      let _this = this;
      data.forEach((item, index) => {
        console.log(item.faultTypesName);
        if (index === 0) {
          _this.spanArr.push(1);
          _this.contactDot = 0;
        } else {
          if (item.faultTypesName == data[index - 1].faultTypesName) {
            _this.spanArr[_this.contactDot] += 1;
            _this.spanArr.push(0);
          } else {
            _this.contactDot = index;
            _this.spanArr.push(1);
          }
        }
        console.log(this.spanArr);
      });
    },
    //查询已添加故障大类小类维修方式
    getModelFaultSolutionList() {
      let para = {
        brandId: this.defaultBrandId,
        categoryId: this.defaultCategoryId,
        modelId: this.defaultModelId,
        faultTypesId: this.defaultFaultClassId,
        faultSubclassId: this.defaultSubClassId,
        startRow: this.pages.page,
        pageSize: this.pages.pageSize,
        state: this.statusList.state,
        partChannel: this.officialAccessoriesList.state,
        extendValue: this.searchSkuNo
      };
      selectModelFaultSolution(para)
        .then(res => {
          if (res.data.status == 100) {
            this.returnData = res.data.results.list;
            this.pages.total = res.data.results.total;
            // console.log(this.returnData)
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //清空dialogvalue
    emptyDialog() {
      this.$refs["exitForm"].resetFields();
      this.dislog = false;
    },
    //查询品牌or获取品牌
    getBrandLists() {
      selectAllBrand()
        .then(res => {
          if (res.data.status == 100) {
            this.brandLists = res.data.results;
            if (res.data.results.length > 0) {
              this.defaultBrandId = res.data.results[0].brandId;
            }
            this.getCategoryList(this.defaultBrandId);
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //选中品牌
    selectBrand(item, index) {
      this.getCategoryList();
      this.defaultCategoryId = "";
      this.defaultModelId = "";
    },
    //获取品类
    getCategoryList() {
      selectCategory({ brandId: this.defaultBrandId })
        .then(res => {
          if (res.data.status == 100) {
            this.categoryLists = res.data.results;
            if (res.data.results.length > 0) {
              this.defaultCategoryId = res.data.results[0].categoryId;
            }
            this.getModelList(this.defaultBrandId, this.defaultCategoryId);
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //选中品类
    selectCategory(item, index) {
      this.defaultModelId = "";
      this.getModelList();
    },
    //获取型号
    getModelList() {
      let para = {
        brandId: this.defaultBrandId,
        categoryId: this.defaultCategoryId
      };
      selectModel(para)
        .then(res => {
          if (res.data.status == 100) {
            this.modelLists = res.data.results;
            if (res.data.results.length > 0) {
              this.defaultModelId = res.data.results[0].modelId;
            }
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //选中型号
    selectModel() {
      //this.getModelFaultSolutionList();
    },
    //选中故障大类
    selectFaultClassId() {
      //this.getFaultList();
    },
    //获取故障大类故障小类
    getModelFaultTypesList() {
      selectModelFaultTypes()
        .then(res => {
          if (res.data.status == 100) {
            this.faultTypesList = res.data.results;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    getRepairList() {
      selectSolution()
        .then(res => {
          if (res.data.status == 100) {
            this.repairLists = res.data.results;
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //编辑
    exitBtn(index, item) {
      console.log('exitBtn', item);

      if (!item) {
        return
      }

      if (!item.serviceMode) {
        item.serviceMode = []
      } else {
        item.serviceMode = item.serviceMode.split(',')
      }

      this.dislog = true;
      this.exitForm = Object.assign({}, item);
      this.imageUrl = this.exitForm.detailUrl;
    },
    getSolution(e) {
      for (var i in this.repairLists) {
        if (e === this.repairLists[i].solutionId) {
          this.selectSolutionId = this.repairLists[i].solutionId;
        }
      }
    },
    //新增故障大类
    saveEventFormSubmitBtn(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let para = {
            brandId: this.defaultBrandId,
            categoryId: this.defaultCategoryId,
            modelId: this.defaultModelId,
            faultTypesId: this.exitForm.faultTypesId,
            faultSubclassId: this.exitForm.faultSubclassId,
            solutionId: this.exitForm.solutionId,
            price: this.exitForm.price,
            originalPrice: this.exitForm.originalPrice,
            duration: this.exitForm.duration,
            warrantyPeriod: this.exitForm.warrantyPeriod,
            extendValue: this.exitForm.extendValue,
            state: this.exitForm.state,
            isShowLine: this.exitForm.isShowLine,
            officialAccessories: this.exitForm.officialAccessories,
            officialPrice: this.exitForm.officialPrice,
            partType: this.exitForm.partType, //类型
            isDiscounts: this.exitForm.isDiscounts, //是否打折
            partNameType: this.exitForm.partNameType, //部件名称类型
            partChannel: this.exitForm.partChannel, //渠道类型
            detailUrl: this.exitForm.detailUrl, //详情图片
            serviceMode: this.exitForm.serviceMode.join(',') //适用服务模式 逗号分隔
          };
          insertModelFaultSolution(para)
            .then(res => {
              if (res.data.status == 100) {
                this.$message({
                  message: res.data.message,
                  type: "success"
                });
                /*刷新*/
                this.getModelFaultSolutionList();
                this.reload();
                /*关闭弹窗，重置输入框*/
                this.dislog = false;
                this.$refs[formname].resetFields();
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.$Message.error(error.message);
            });
        } else {
          console.log("验证未通过");
          return false;
        }
      });
    },
    //编辑故障大类
    saveStateSubmitBtn(formName) {
      console.log(this.exitForm.officialAccessories);
      console.log(this.exitForm.originalPrice);
      this.$refs[formName].validate(valid => {
        if (valid) {
          let para = {
            modelFaultSolutionId: this.exitForm.modelFaultSolutionId,
            state: this.exitForm.state,
            price: this.exitForm.price,
            originalPrice: this.exitForm.originalPrice,
            solutionId: this.exitForm.solutionId,
            duration: this.exitForm.duration,
            warrantyPeriod: this.exitForm.warrantyPeriod,
            extendValue: this.exitForm.extendValue,
            officialAccessories: this.exitForm.officialAccessories,
            isShowLine: this.exitForm.isShowLine,
            officialPrice: this.exitForm.officialPrice,
            partType: this.exitForm.partType, //类型
            isDiscounts: this.exitForm.isDiscounts, //是否打折
            partNameType: this.exitForm.partNameType, //部件名称类型
            partChannel: this.exitForm.partChannel, //渠道类型
            detailUrl: this.exitForm.detailUrl, //详情图片
            serviceMode: this.exitForm.serviceMode.join(',') //适用服务模式 逗号分隔
          };
          //console.log(para)
          deleteModelFaultSolution(para)
            .then(res => {
              //console.log(res)
              if (res.data.status == 100) {
                this.$message({
                  message: res.data.message,
                  type: "success"
                });
                /*刷新*/
                this.getModelFaultSolutionList();
                this.reload();
                /*关闭弹窗，重置输入框*/
                this.dislog = false;
                this.$refs[formname].resetFields();
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.$Message.error(error.message);
            });
        } else {
          console.log("验证未通过");
          return false;
        }
      });
    },
    //修改维修方式
    exitRepair(item, m) {
      this.exitForm = Object.assign({}, m);
      this.defaultFaultTypesId = Object.assign({}, item).faultTypesId;
      this.defaultFaultSubclassId = Object.assign({}, m).faultSubclassId;
      this.dislog = true;
    }
  },
  computed: {
    mapForChannel() {
      //console.log(this.faultTypesList)
      let map = [];
      if (this.faultTypesList && this.faultTypesList.length) {
        this.faultTypesList.forEach(item => {
          map[item.faultTypesId] = item.faultTypesName;
          // item.faultSubclasses.forEach(itemss =>{
          // map[itemss.faultSubclassId] = itemss.faultSubclassName
          // })
          map[item.faultSubclassId] = item.faultSubclassName;
        });
      }
      return map;
      // console.log(map[0])
    },
    mapForRepair() {
      //console.log(this.repairLists)
      let map = [];
      if (this.repairLists && this.repairLists.length) {
        this.repairLists.forEach(item => {
          map[item.solutionId] = item.solutionName;
        });
      }
      return map;
    }
  },
  created: function() {
    var token = "";
    var policy = {};
    var bucketName = "hohofast";
    var AK = "VYiFElH26Am5EbV9T3nACEfNt6xBRz6gEREDFlis";
    var SK = "sFELHoXSwB8NpiWpPj2Wk7theJCO7Iil-2rwSj31";
    var deadline = Math.round(new Date().getTime() / 1000) + 3600;
    policy.scope = bucketName;
    policy.deadline = deadline;
    token = genUpToken(AK, SK, policy);
    this.postData.token = token;
  },
  watch: {}
};
</script>

<style lang="scss" type="text/css" scoped>
#repairModeManage {
  font-size: 14px;
  .repair-content {
    display: flex;
    .item1 {
      width: 300px;
    }
    .item2 {
      width: 75%;
      margin-left: 10px;
    }
  }
  .headerT {
    margin: 8px 0 15px 0;
    width: 80px;
    display: inline-block;
  }
  .clearfix {
    clear: both;
    overflow: hidden;
  }
  .headerSpan {
    margin-right: 20px;
    display: block;
  }
  .listPart {
    border: 1px solid #c6c6c6;
    margin: 10px 10px 10px 0;
    border-radius: 5px;
    text-align: center;
    position: relative;
    z-index: 0;
    cursor: pointer;
    padding: 5px 10px;
    width: 130px;
  }
  li.active {
    background-color: #1abc9c;
    color: #fff;
    border-color: #1abc9c;
  }
  .el-checkbox.is-bordered + .el-checkbox.is-bordered {
    margin-left: 15px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// faultRepair.vue?169096a4